import { inject, Injectable } from '@angular/core';
import { PreloadingStrategy, Route, Router } from '@angular/router';
import { Observable, of } from 'rxjs';

/** Route prefix shared by `/dicom-viewer/:id` and the anonymous `/dicom-viewer-share?token=...` link. */
const DICOM_VIEWER_URL_PREFIX = '/dicom-viewer';

/**
 * `PreloadAllModules` for the whole app, except while the full-screen DICOM viewer is the page:
 * its opener (often an emailed share link, not even signed in) only needs the viewer, yet preloading
 * every feature route downloaded all of billing, patients, inpatient ... in the background while the
 * viewer was still starting up. Those chunk requests queued ahead of the viewer's own chunks and its
 * metadata call (hundreds of requests in a dev build) and are never used from that page.
 *
 * `RouterPreloader` re-runs this after every navigation, so leaving the viewer for a normal page
 * resumes preloading as before.
 */
@Injectable({ providedIn: 'root' })
export class ViewerAwarePreloadingStrategy implements PreloadingStrategy {
  private readonly router = inject(Router);

  preload(_route: Route, load: () => Observable<unknown>): Observable<unknown> {
    return this.router.url.startsWith(DICOM_VIEWER_URL_PREFIX) ? of(null) : load();
  }
}
